import React ,{useState,useEffect,useRef} from 'react'
import Constants from '../../../Constants';
import $ from 'jquery'
import { TIME_LIST,transformBlankToNull,checkUpdateBidDateDisabledCondition,disabledSelectStyle} from '../../../services/Util';
import { putAxiosResponse } from '../../../services/authApiRoutes/APImethods';
import APIUrls from '../../../services/APIUrls';
import Select from 'react-select';
import DatePickerCalendar from '../../dashboard/calendars/DatePickerCalendar';
import { calenderIcon } from '../../../AppIcons';
import moment from 'moment';
import dateUtil from "../../../services/DateUtil";
import DateFormat from "../../../pages/DateFormat";

export default function BidNeedMoreTime(prop) {
    const [exceedLimitError, setExceedLimitError] = useState(false);
    const [bidDueDate, setBidDueDate] = useState(null);
    const [bidDueTime, setBidDueTime] = useState(-1);
    const [deliveryDueTime, setDeliveryDueTime] = useState(-1);
    const [deliveryDueDate, setDeliveryDueDate] = useState(null);
    const [minDeliveryDueDate, setMinDeliveryDueDate] = useState(null);
    const [toggle, toggleCal] = useState(false);
    const [toggleIntialCal, toggleIntialCalFlag] = useState(false);
    const [errorData, setErrorData] = useState([]);
    const [bidSelectDeadlineDate, setBidSelectDeadlineDate] = useState("");

    const refToggle = useRef(null);
    const refToggle2 = useRef(null);
    const refCalendar = useRef(null);
    const refCalendar2 = useRef(null);

    const project = Object.assign({}, prop.projectDetail.resource.projectResource);

    const calculateBidSelectionDeadline = () => {
        var differenceInHours = moment(deliveryDueDate).diff(bidDueDate, "hours");
    
        differenceInHours = differenceInHours * 0.25;
    
        var hoursToAddToBidDueDate = Math.abs(differenceInHours);
    
        if (hoursToAddToBidDueDate < 2) {
          hoursToAddToBidDueDate = 2;
        }
        
        var updatedDate = new Date(bidDueDate).setHours( new Date(bidDueDate).getHours() + hoursToAddToBidDueDate );
        setBidSelectDeadlineDate(updatedDate);
        return updatedDate;
      };

    useEffect(() => {
        if(!bidDueDate || !deliveryDueDate) {
            const bidDueDateTimestamp = dateUtil.convertToLocalDateTimestamp(project?.bidDueDate);
            const deliveryDueDateTimestamp = dateUtil.convertToLocalDateTimestamp(project?.deliveryDueDate);
            const bidSelectDeadlineDateTimestamp = dateUtil.convertToLocalDateTimestamp(project?.bidSelectDeadlineDate);
            setBidDueDate(bidDueDateTimestamp);
            setDeliveryDueDate(deliveryDueDateTimestamp);
            setBidSelectDeadlineDate(bidSelectDeadlineDateTimestamp);
            setBidDueTime(moment(bidDueDateTimestamp).hours());
            setDeliveryDueTime(moment(deliveryDueDateTimestamp).hours());
        }
    }, [project])

    useEffect(() => {
      if(bidDueTime !== -1 || bidDueDate || deliveryDueDate || deliveryDueTime !== -1) {
        calculateBidSelectionDeadline();
      }
    }, [bidDueTime, bidDueDate, deliveryDueDate, deliveryDueTime]);

    useEffect(() => {
      if(bidDueDate) {
        initMinDeliveryDueDate();
      }
    }, [bidDueTime, bidDueDate]);

    useEffect(() => {
        bumpDeliveryDueDate();
    }, [minDeliveryDueDate]);

    useEffect(() => {
        if(moment(deliveryDueDate).isBefore(minDeliveryDueDate)) {
            setDeliveryDueDate(minDeliveryDueDate);
            setDeliveryDueTime(moment(minDeliveryDueDate).hours());
        }
    }, [deliveryDueDate])

    const showCalendarDeliveryDate = () => {
        toggleIntialCal ? toggleIntialCalFlag(false) : toggleIntialCalFlag(true);
        $(document.activeElement).toggleClass('calSecondFocus')
        $('.calSecondFocus').trigger('focus')
        $(document).mouseup(function(e) {
          var bannerCont = $('.caltopset');
          if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
            toggleIntialCalFlag(false)
            $('.calSecondFocus').removeClass('calSecondFocus')
         }
         });
        if (toggleIntialCal) {
          var requiredElement = document.querySelector(".dashCalendarMachine");
          if (requiredElement !== null) {
            requiredElement.focus();
          }
        }
      };

    const bidDueTimeChangeHandler = (event) => {
        let hour = parseInt(event.value);
        var newBidDueDate = moment(bidDueDate)
        newBidDueDate.set({
            'hour': hour,
            'minute': 0,
            'second': 0,
            'millisecond': 0,
        })
        setBidDueDate(newBidDueDate.valueOf());
        setBidDueTime(hour);
    }
    const deliveryDueTimeChangeHandler = (event) => {
        let hour = parseInt(event.value);
        var newDeliveryDueDate = moment(deliveryDueDate)
        newDeliveryDueDate.set({
            'hour': hour,
            'minute': 0,
            'second': 0,
            'millisecond': 0,
        })
        setDeliveryDueDate(newDeliveryDueDate.valueOf());
        setDeliveryDueTime(hour);
    }

    const initMinDeliveryDueDate = () => {
        let minDate = moment(bidDueDate).add(4, "hours");
        if(minDate.hours() > 17) {
            minDate = minDate.add(1, "days");
            minDate.set({
                'hour': 0,
                'minute': 0,
                'second': 0,
                'millisecond': 0,
            });
        }
        setMinDeliveryDueDate(minDate.valueOf());
    }

    const bumpDeliveryDueDate = () => {
        if (moment(minDeliveryDueDate).isAfter(moment(deliveryDueDate), "hours")) {
            var nextDayDate = moment(bidDueDate).add(1, 'days');
            nextDayDate.set({
                'hour': 17, // 5 PM fixed
                'minute': 0,
                'second': 0,
                'millisecond': 0,
            });
            setDeliveryDueDate(nextDayDate.valueOf());
            setDeliveryDueTime(nextDayDate.hours());
        }
    }

    const bidDueDateChangeHandler = (event) => {
        let newBidDueDate = new Date(event).setHours(bidDueTime)
        setBidDueDate(newBidDueDate);
        $('.calFirstFocus').trigger('focus')
        $('#calFirstFocus').removeClass('calFirstFocus')
        $(document).on('mouseup', function(e) {
          var bannerCont = $('.calFirstFocus');
          if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
            $('.calFirstFocus').trigger('focus')
            $('#calFirstFocus').removeClass('calFirstFocus')
          }
        });
        toggleCal(false);
      };
      const deliveryDueDateChangeHandler = (event) => {
        let newDeliveryDueDate = new Date(event).setHours(deliveryDueTime)
        setDeliveryDueDate(newDeliveryDueDate);
        $('.calSecondFocus').trigger('focus')
        $('#calSecondFocus').removeClass('calSecondFocus')
        $(document).on('mouseup', function(e) {
          var bannerCont = $('.calSecondFocus');
          if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
            $('.calSecondFocus').trigger('focus')
            $('#calSecondFocus').removeClass('calSecondFocus')
          }
        });
        toggleIntialCalFlag(false);
      };  
    const closeCalendar = (e) => {
        if (e.code === Constants.ESCAPE) {
          if ($('.calFirstFocus').length) {
            setTimeout(() => {
              toggleCal(false);
              $('.calFirstFocus').trigger('focus')
              $('#calFirstFocus').removeClass('calFirstFocus')
            }, 100);
          } else if ($('.calSecondFocus').length) {
            setTimeout(() => {
            toggleIntialCalFlag(false);
            $('.calSecondFocus').trigger('focus')
            $('#calSecondFocus').removeClass('calSecondFocus')
          }, 100);
          }
        }
      };
    function hideModel() {
        setExceedLimitError(false);
        document.body.classList.remove("modal-open");
        $('.showPopup').trigger('focus');
        $('.showPopup').removeClass('showPopup');
        $('.small-dropdown-select > div').addClass('hide')
      }
      const showCalendarDueDate = () => {
        toggle ? toggleCal(false) : toggleCal(true);
        $(document.activeElement).toggleClass('calFirstFocus')
        $('.calFirstFocus').trigger('focus')
        $(document).mouseup(function(e) {
          var bannerCont = $('.firstCal');
          if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
            toggleCal(false)
            $('.calFirstFocus').removeClass('calFirstFocus')
         }
        });
        if (toggle) {
          var requiredElement = document.querySelector(".dashCalendar");
          if (requiredElement !== null) {
            requiredElement.focus();
          }
        }
      };
    const escapeModal = (event) => {
        let allAreFalse = true;
        $('.small-dropdown-select').each(function() {
          if ($(this).find('input').attr('aria-expanded') !== 'false') {
            allAreFalse = false;
            return false;
          }
        });
        if(event.key === Constants.TAB && event.shiftKey) {
          if ($(event.target).hasClass('close')) {
            event.preventDefault();
            if ($('#confirmNeedMoreTime').prop('disabled')) {
              event.preventDefault();
              $('#cancelQuoteDeadline').trigger('focus');
            } else {
              event.preventDefault();
              $('#confirmNeedMoreTime').trigger('focus');
            }
          }
        } else if (event.key === Constants.TAB && !event.shiftKey) {
          if ($(event.target).attr('id') === 'confirmNeedMoreTime' ||
              (($(event.target).attr('id') === 'cancelQuoteDeadline') &&
              $('#confirmNeedMoreTime').prop('disabled'))) {
            event.preventDefault();
            $('.close').trigger('focus');
          }
        } else if (event.key === Constants.ESCAPE
          && allAreFalse
          && !($('.calFirstFocus').length) &&
          !($('.calSecondFocus').length)) {
          if ($('#needMoreTimePopup').length) {
            hideModel();
          }
          
        }
      }
      const updateDeadlineDate = () => {
        var error = {
          bidDueDate: "",
          deliveryDueDate: ""
        };
        if (!bidDueDate) {
          error.bidDueDate = "error";
          setErrorData(error);
        }
        if (!deliveryDueDate) {
          error.deliveryDueDate = "error";
          setErrorData(error);
        }
    
        if (!error.bidDueDate && !error.deliveryDueDate) {
          if (bidDueDate !== dateUtil.getDateTimestamp(project.bidDueDate)) {
            project.bidDueDateChanged = true;
            project.bidDueDate = dateUtil.convertToServerDateTsObj(bidDueDate);
          }
          if (deliveryDueDate !== dateUtil.getDateTimestamp(project.deliveryDueDate)) {
            project.deliveryDueDateChanged = true;
            project.deliveryDueDate = dateUtil.convertToServerDateTsObj(deliveryDueDate);
          }
          if (bidSelectDeadlineDate !== dateUtil.getDateTimestamp(project.bidSelectDeadlineDate)) {
            project.bidSelectDeadlineDate = dateUtil.convertToServerDateTsObj(bidSelectDeadlineDate);
          }
          project.errors = {};
          project.status = "SUBMITTED_FOR_BIDS";
          var payload = transformBlankToNull(project);
          putAxiosResponse(APIUrls.PROJECT(project.id), payload).then((res) => {
            prop.refresh()
            prop.showPopup()
            hideModel();
          });
        }
      };

      const GetBidSelectionDeadlineDate = () => {
        let deadlineDate;
        let timeLabel;
        if(bidSelectDeadlineDate) {
            deadlineDate = dateUtil.format(bidSelectDeadlineDate, null, null);
            timeLabel = dateUtil.getTimeDropdownVal(bidSelectDeadlineDate).label
        }
        return `${deadlineDate} at ${timeLabel}`;
      }

      const deliveryTimeOptions = () => {
          const timeList = JSON.parse(JSON.stringify(TIME_LIST));
          return timeList.map((option) => {
              if(option.value >= 0 && moment(deliveryDueDate).isSame(bidDueDate, 'day') && option.value < bidDueTime + 4) {
                  option.isDisabled = true;
              }
              return option;
          });
      }

  return (
    <div id="needMoreTimePopup" className="lightbox-panel bid-extended modelPopup" aria-labelledby="needMoreTime" aria-modal="true" role="dialog"
          onKeyDown={(e)=>escapeModal(e)}>
            <div className="inner-lightbox-panel">
              <div className="modal-header flex">
                <strong id="needMoreTime">Extend the Quote Selection Deadline</strong>
              </div>
              <div className="lightbox-content vender-form-block overflow-inherit">
                <span className="alert-icon">
                  Changing the project dates will require Vendors to provide new
                  quote, and all submitted quote will be removed. If you do not
                  want to restart quotation, click "Cancel". Otherwise, click "OK"
                  and vendors will be notified of your changes.
                </span>
                <div className="flex wrap-dropdown wrap-group-dropdown">
                  <div className="global-dropdown-block flex-center firstCal">
                    <label htmlFor="calFirstFocus">Vendors must submit quotes by</label>
                    <div className="flex-center w-d100">
                      <div className="global-dropdown-select">
                        <button type="button" onClick={(e) => { showCalendarDueDate(e); }} id='calFirstFocus' ref={refToggle}
                          className="drop-down-btn gb-dropBtn" aria-expanded={toggle ? 'true':'false'} aria-label={toggle ? 'choose date dialog':
                          dateUtil.format(bidDueDate, null, null)}>
                          <span aria-hidden="true">
                              <DateFormat date={bidDueDate} timezone={null} />
                          </span>
                          {calenderIcon}
                        </button>
                      </div>
                      {toggle ? (<div ref={refCalendar} onKeyDown={(e) => { closeCalendar(e); }}>
                          <DatePickerCalendar minDate={new Date()} className="dashCalendarDeadLine"
                             value={ new Date(bidDueDate) } selectDate={bidDueDateChangeHandler}/>
                        </div>
                      ) : ( "" )}
                      <div className="global-dropdown-select small-dropdown-select">
                        <Select classNamePrefix="cw" value={dateUtil.getTimeDropdownVal(bidDueTime)}
                          aria-label="What Time?" onChange={(event) => bidDueTimeChangeHandler(event)} options={TIME_LIST} menuShouldScrollIntoView={false}/>
                      </div>
                    </div>
                    {errorData.bidDueDate !== "" && errorData.length !== 0 ? (
                      <span className="error mb-0">
                        {" "}
                        Please select a valid date
                      </span>
                    ) : null}
                  </div>
                </div>
                <div className="flex wrap-dropdown wrap-group-dropdown">
                  <div className="global-dropdown-block flex-center caltopset">
                    <label htmlFor="calSecondFocus">I need initial translation by</label>
                    <div className="flex-center w-d100">
                      <div className="global-dropdown-select">
                        <button type="button" onClick={(e) => {showCalendarDeliveryDate(e);}} ref={refToggle2} id='calSecondFocus'
                          className="drop-down-btn gb-dropBtn" aria-expanded={toggleIntialCal ? 'true':'false'}
                          aria-label={toggle ? 'choose date dialog': dateUtil.format(deliveryDueDate, null, null)}>
                          <span aria-hidden="true">
                              <DateFormat date={deliveryDueDate} timezone={null} />
                          </span>
                          {calenderIcon}
                        </button>
                      </div>
                      {toggleIntialCal ? ( <div ref={refCalendar2} onKeyDown={(e) => { closeCalendar(e); }}>
                          <DatePickerCalendar value={ new Date(deliveryDueDate) }
                            minDate={ new Date(minDeliveryDueDate) }
                            className="dashCalendarMachine" selectDate={deliveryDueDateChangeHandler}/>
                        </div>
                      ) : ( "" )}
                      <div className="global-dropdown-select small-dropdown-select">
                        <Select classNamePrefix="cw" aria-label="What Time?" menuShouldScrollIntoView={false}
                                options={deliveryTimeOptions()}
                                value={dateUtil.getTimeDropdownVal(deliveryDueTime)}
                                onChange={deliveryDueTimeChangeHandler}
                                isOptionDisabled={(option) => option.isDisabled}
                                styles={disabledSelectStyle}/>
                      </div>
                    </div>
                    {errorData.deliveryDueDate !== "" && errorData.length !== 0 ? (
                      <span className="error">Please select a valid date</span> ) : null}
                  </div>
                </div>
                <div >
                  <strong>Your will have to select the quote by:</strong>
                  <p><GetBidSelectionDeadlineDate /></p>
                </div>
              </div>
              <div className="modal-footer flex">
                <button id="cancelQuoteDeadline" className="btn btn-bold" onClick={hideModel}>
                  Cancel
                </button>
                <button id="confirmNeedMoreTime" className="btn btn-bold active" disabled={checkUpdateBidDateDisabledCondition(project,bidDueDate,deliveryDueDate)}
                  onClick={updateDeadlineDate}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
  )
}
